import './MainSideBar.scss'

import Menu, { MenuItem } from '../../components/Menu/Menu'
import React, { Fragment, useCallback, useState } from 'react'

import Button from '../../components/Button/Button'
import classNames from 'classnames'
import t from '../../helpers/i18n'
import { useSelector } from 'react-redux'

const MainSideBar = () => {
  return (
    <div className="main-side-bar">
      <FootballMenu />
    </div>
  )
}

const OrganizationButton = ({ onClick }) => {
  return (
    <div className='main-side-bar-organization' onClick={onClick}>
      <div className='-logo'></div>
      <div className='-info'>
        <div className='-name proper-noun-default-semibold'>Sample Name</div>
        <div className='-tags'>
          <div className='-sport'>{t('roles.Football')}</div>
          <div className='-role'>{t('roles.Owner')}</div>
        </div>
      </div>
    </div>
  )
}

const FootballMenu = () => {
  const profile = useSelector(state => state.profile)
  const [organizationMenu, setOrganizationMenu] = useState()

  const handleOpen = useCallback(() => setOrganizationMenu(true), [
    setOrganizationMenu
  ])
  const handleClose = useCallback(() => setOrganizationMenu(false), [
    setOrganizationMenu
  ])

  return (
    <Fragment>
      {profile.products.BETA &&
        <Fragment>
          <OrganizationButton onClick={handleOpen}/>
          <Menu colorfull>
            <MenuItem title={t('menu.Dashboard')} icon="DashboardIcon" link="/soccer/dashboard" />
          </Menu>
          <Menu colorfull title={t('menu_titles.Football_Manager')}>
            <MenuItem title={t('menu.Clubs')} icon="ClubsInstitutionsIcon" link="/soccer/clubs" />
            <MenuItem title={t('menu.Players')} icon="PlayersIcon" />
            <MenuItem title={t('menu.Technical_Staff')} icon="TechnicalStaffIcon" />
            <MenuItem title={t('menu.Delegates')} icon="DelegatesIcon" />
            <MenuItem title={t('menu.Referee_Officials')} icon="RefereesIcon" />
            <MenuItem title={t('menu.Venues')} icon="VenuesIcon" />
            <MenuItem title={t('menu.Competitions')} icon="CompetitionsIcon" />
          </Menu>
          <Menu colorfull title={t('menu_titles.Add_ons')}>
            <MenuItem title={t('menu.Document_Center')} icon="DocumentCenterIcon" link="#" />
            <MenuItem title={t('menu.Sponsors')} icon="SponsorsIcon" link="#" />
            <MenuItem title={t('menu.Finance')} icon="FinanceIcon" link="#" />
            <MenuItem title={t('menu.Message_Board')} icon="MessageBoardIcon" link="#" />
          </Menu>

          <div className={classNames("main-side-bar-organization-menu", { "-visible": organizationMenu })}>
            <div className="-logo"></div>
            <div className="-name"></div>
            <div className="-title overline-label-medium-medium">{t('titles.Organization_Settings')}</div>
            <div className="-back">
              <Button label={t("buttons.Exit_Settings_Panel")} onClick={handleClose} />
            </div>
            <Menu colorfull>
              <MenuItem title={t('menu.General_Settings')} icon="InformationIcon" />
              <MenuItem title={t('menu.Members')} icon="CollaboratorsIcon" link="/soccer/members" />
              <MenuItem title={t('menu.Public_Website')} icon="WebsiteIcon" />
              <MenuItem title={t('menu.Subscription_&_Billing')} icon="SubscriptionBillingIcon" />
              <MenuItem title={t('menu.Add_ons_Store')} icon="AddOnsStoreIcon" />
            </Menu>
          </div>
        </Fragment>
      }
      {profile.products.SOCCER &&
        <Menu colorfull title={t("menu_titles.Administration")}>
          <MenuItem title={t('menu.Sites')} icon="WebsiteIcon" link="/soccer/sites" />
          {profile.products.BETA && <MenuItem title={t('menu.Avatars')} link="/soccer/old/teams" />}
          <MenuItem title={t('menu.Matches')} icon="ClubsInstitutionsIcon" link="/soccer/old/games" />
          <MenuItem title={t('menu.Competitions')} icon="CompetitionsIcon" link="/soccer/competitions" />
        </Menu>
      }
    </Fragment>
  )
}

export default MainSideBar
